import React from "react"
import { Route, Switch } from "react-router-dom"
import { ListItem, ListItemIcon, ListItemText, Typography } from "@material-ui/core/"
import HomeIcon from "@material-ui/icons/Home"
import ExitToAppIcon from "@material-ui/icons/ExitToApp"
import { Link } from "react-router-dom"
import { useHistory, useLocation } from "react-router-dom"

//Components
import Alertas_Generica from "../../alertas_genericas/pages/alertasadministar.js"
import Acompanamiento from "../../acompanamiento_docente/acompanamientoDocente"
import AcompanamientoAdm from "../../acompanamiento_docente/acompanamientoAdministrar"
import Genericas from '../../genericas/Genericas'
import Elecciones from '../../elecciones/Elecciones'
import EleccionesVotar from '../../elecciones/EleccionesVotar'
import Inicio from '../../general/Inicio'
import Personas from '../../personas/Personas'
import Practicas from '../../practicas/Practicas'
import PracticasAgregarActa from '../../practicas/PracticasAgregarActa'
import PracticasAgregarActaAlt from '../../practicas/PracticasAgregarActaAlt'
import PracticasAdministrar from '../../practicas/administrar/PracticasAdministrar'
import InscripcionAgregar from '../../inscripciones/InscripcionAgregar'
import MatriculasRT from '../../matriculas/MatriculasReintTrans'
import Ingresar from './Ingresar'
import Inscripciones from '../../inscripciones/administrar/Inscripciones'
import Not_Found from '../app/Not_Found'
import { api } from "../../../global/js/funciones"
import Becas from "../../becas/Becas"
import BecasAdministrar from "../../becas/administrar/BecasAdministrar"
import Matriculas from "../../matriculas/Matriculas"
import MatriculasAdm from "../../matriculas/MatriculasAdm"
import CreditosAdministrar from "./../../creditos/CreditosAdministrar"
import CreditosEstudiantes from "./../../creditos/CreditosEstudiantes"
import Asistencia from "./../../asistencia/Asistencia"
import MatriculasConf from "../../matriculas/MatriculasConf"
import ValidacionesEstudiantes from "../../validaciones/ValidacionesEstudiantes"
import ValidacionesAdministrar from "../../validaciones/ValidacionesAdministrar"
import SolicitudesAgregar from "../../consultoria/SolicitudesAgregar"
import Preguntas from "../../preguntas/Preguntas"
import PoliticaPrivacidad from "../PoliticaPrivacidad.js"
import Biblioteca from "../../biblioteca/Biblioteca"
import GestionBiblioteca from "../../biblioteca/GestionBiblioteca"
import Encuesta from "../../encuesta/Encuesta"
import EncuestaGeneral from "../../encuesta/EncuestaGeneral"
import SesionTerminada from "./SesionTerminada"
import Invitados from "../../invitados/Invitados"
import InvitadosGestion from "../../invitados/InvitadosGestion"
import Reportes from "../../reportes/Reportes"
import ReaEstudiantes from "../../rea/ReaEstudiantes"
import ReaAdministrar from "../../rea/ReaAdministrar"
import ReaDocente from "../../rea/ReaDocente"
import Consultoria from "../../consultoria/administrar/ConsultoriaAdministrar"
import TutoriaEstudiantes from "../../tutorias/TutoriasEstudiantes"
import TutoriasAdministrar from "../../tutorias/TutoriasAdministrar"
import Internacionalizacion from "../../internacionalizacion/Internacionalizacion"
import AdministrarInternacionalizacion from "../../internacionalizacion/administrar/AdministrarInternacionalizacion"
import AutodiagnosticoAdministrar from "../../autodiagnostico/AutodiagnosticoAdministrar"
import AutodiagnosticoEstudiantes from "../../autodiagnostico/AutodiagnosticoEstudiantes"
import Consultas from "../../consultas/Consultas.js"

import Portal from "./../../portal/Portal"
import PortalEmpresa from "../../portal/Empresa"
import PortalGestion from "../../portal/PortalGestion"

import AdminEncuesta from "../../encuesta/AdminEncuestas"

//import RetosAdministrar from "../../retos/RetosAdministrar";
// import RetosAdministrar from "../../retos/RetosAdministrar";
import ReporteVacuna from "../../reporteVac/ReporteVacuna"

//import Semileros de Investigacion
import SemilleroPrincipal from "../../semilleros/SemilleroPrincipal";
import SemilleroAdministrador from "../../semilleros/SemilleroAdministrador"
import SemilleroEstudiante from "../../semilleros/SemilleroEstudiante"
import Semilleros from "../../semilleros/Semilleros"
import PreInscripcionAgregar from "../../inscripciones/preinscripciones/PreInscripcionAgregar"
import Ova from "../../ova/Ova"
import Entrevistas from "../../entrevistas/Entrevistas"
import PromocionAdministrar from "../../promocion/PromocionAdministrar"
import Grados from '../../grados/Grados'
import GradosAdm from './../../grados/GradosAdm'
import InvitadosVirtualEstudiante from "../../invitadosVirtual/InvitadosVirtualEstudiantes"
import InvitadosVirtualGestion from "../../invitadosVirtual/InvitadosVirtualAdministrar"
import RetosEstudiantes from '../../retoscuc/RetosEstudiantes'
import RetosAdministrar from '../../retoscuc/RetosAdministrar'
import Bloques from '../../bloques/bloques'
import AdminSalas from '../../bloques/AdminSalas/AdminSalas'
import CursoEstudiante from '../../cursodeformacion/CursoEstudiante'
import GestionarCurso from "../../cursodeformacion/Cursos/gestionar/GestionarCurso"
import InscripcionPosgradoAgregar from "../../inscripciones_posgrado/InscripcionPosgradoAgregar"
import InscripcionesPosgrados from "../../inscripciones_posgrado/InscripcionesPosgradoAdministrar"
import AtencionEstudiantes from '../../atencion/AtencionEstudiantes'
import AtencionAdministrar from '../../atencion/AtencionAdministrar'
import CentroConciliacion from '../../centro/administrar/CentroConciliacionAdministrar'
import Sisef from "../../sisef/Sisef";
import SisefEstudiante from "../../sisef/SisefEstudiante"
import EncuestaGraduados from "../../matriculas/matriculas/grados/encuesta_graduados/EncuestaGraduados.js"
import AutogestionEstudiante from '../../autogestion_estudiantil/AutogestionEstudiante.js'
import Politica from "./Politica.js";
import BienestarEstudiante from "../../bienestar_estudiantil/BienestarEstudiante.js"
import BienestarAdministrar from "../../bienestar_estudiantil/BienestarAdministrar.js"
import AdminEncuestaGenero from "../../general/encuesta_genero/AdminEncuestaGenero.js"
import ProyectoVida from "../../proyecto_vida/ProyectoVida"
import GestionProyectoVida from "../../proyecto_vida/GestionProyectoVida"

// ✅ Buscar en el menú (antes de Inicio)
import { Buscar } from "../../general/app/Buscar";


const obtenerActividades = () => {
  return [
    {
      codigo: "personas_act",
      nombre: "personas",
      componente: () => Personas,
    },
    {
      codigo: "genericas_act",
      nombre: "genericas",
      componente: () => Genericas,
    },
    {
      codigo: "votaciones_act",
      nombre: "mis_votaciones",
      componente: () => EleccionesVotar,
    },
    {
      codigo: "elecciones_act",
      nombre: "votaciones",
      componente: () => Elecciones,
    },
    {
      codigo: "practicas_act",
      nombre: "mis_practicas",
      componente: () => Practicas,
    },
    {
      codigo: "practicasAdm_act",
      nombre: "practicas",
      componente: () => PracticasAdministrar,
    },
    {
      codigo: "inscripciones_act",
      nombre: "inscripciones",
      componente: () => Inscripciones,
    },
    {
      codigo: "becas_act",
      nombre: "becas",
      componente: () => Becas,
    },
    {
      codigo: "becasAdm_act",
      nombre: "becas_adm",
      componente: () => BecasAdministrar,
    },
    {
      codigo: "matriculas_act",
      nombre: "procesos_academicos",
      componente: () => Matriculas,
    },
    {
      codigo: "matriculasAdm_act",
      nombre: "gestion_procesos_academicos",
      componente: () => MatriculasAdm,
    },
    {
      codigo: "matriculasConf_act",
      nombre: "matriculasConf",
      componente: () => MatriculasConf,
    },
    {
      codigo: "creditos_act",
      nombre: "procesos_financieros",
      componente: () => CreditosEstudiantes,
    },
    {
      codigo: "creditos_adm_act",
      nombre: "gestion_procesos_financieros",
      componente: () => CreditosAdministrar,
    },
    {
      codigo: "consultas_act",
      nombre: "consultas",
      componente: () => Consultas,
    },
    {
      codigo: "asistencia_adm_act",
      nombre: "gestion_asistencia",
      componente: () => Asistencia,
    },
    {
      codigo: "invitados_act",
      nombre: "estudiantes_invitados",
      componente: () => Invitados,
    },
    {
      codigo: "invitados_adm_act",
      nombre: "gestion_estudiantes_invitados",
      componente: () => InvitadosGestion,
    },
    {
      codigo: "reportes_act",
      nombre: "reportes",
      componente: () => Reportes,
    },
    {
      codigo: "validaciones_act",
      nombre: "validaciones",
      componente: () => ValidacionesEstudiantes,
    },
    {
      codigo: "validaciones_adm_act",
      nombre: "gestion_validaciones",
      componente: () => ValidacionesAdministrar,
    },
    {
      codigo: "rea_act",
      nombre: "rea",
      componente: () => ReaEstudiantes,
    },
    {
      codigo: "rea_adm_act",
      nombre: "gestion_rea",
      componente: () => ReaAdministrar,
    },
    {
      codigo: "rea_doce_act",
      nombre: "docente_rea",
      componente: () => ReaDocente,
    },
    {
      codigo: "tutorias_act",
      nombre: "tutoria",
      componente: () => TutoriaEstudiantes,
    },
    {
      codigo: "tutorias_adm_act",
      nombre: "gestionTutoria_adm",
      componente: () => TutoriasAdministrar,
    },
    {
      codigo: "consultoria_admin_act",
      nombre: "consultoria_administrar",
      componente: () => Consultoria,
    },
    {
      codigo: "centro_conciliacion_admin_act",
      nombre: "centro_conciliacion_administrar",
      componente: () => CentroConciliacion,
    },
    {
      codigo: "ova_act",
      nombre: "ova",
      componente: () => Ova,
    },
    {
      codigo: "autodiagnostico_est_act",
      nombre: "autodiagnostico",
      componente: () => AutodiagnosticoEstudiantes,
    },
    {
      codigo: "autodiagnostico_act",
      nombre: "gestion_autodiagnostico",
      componente: () => AutodiagnosticoAdministrar,
    },
    {
      codigo: "portal_act",
      nombre: "portal",
      componente: () => Portal,
    },
    {
      codigo: "empresa_act",
      nombre: "empresa",
      componente: () => PortalEmpresa,
    },
    {
      codigo: "admportal_act",
      nombre: "portal_gestion",
      componente: () => PortalGestion,
    },
    {
      codigo: "admencuesta_act",
      nombre: "encuesta_admin",
      componente: () => AdminEncuesta,
    },
    {
      codigo: "reportevac_act",
      nombre: "reporte_vacuna",
      componente: () => ReporteVacuna,
    },
    {
      codigo: "internacionalizacion_act",
      nombre: "internacionalizacion",
      componente: () => Internacionalizacion,
    },
    {
      codigo: "internacionalizacion_adm_act",
      nombre: "internacionalizacion_adm",
      componente: () => AdministrarInternacionalizacion,
    },
    {
      codigo: "semilleros_principal",
      nombre: "semilleros",
      componente: () => SemilleroPrincipal,
    },
    {
      codigo: "semi_est",
      nombre: "semilleros_estudiante",
      componente: () => SemilleroEstudiante,
    },
    {
      codigo: "semi_act",
      nombre: "gestion_semilleros",
      componente: () => SemilleroAdministrador,
    },
    {
      codigo: "semi_pro",
      nombre: "semilleros_profesor",
      componente: () => Semilleros,
    },
    {
      codigo: "entrevistas_act",
      nombre: "historico_entrevistas",
      componente: () => Entrevistas
    },
    {
      codigo: "opcGrados_act",
      nombre: "grados",
      componente: () => Grados,
    },
    {
      codigo: "gradosAdm_act",
      nombre: "gestion_grados",
      componente: () => GradosAdm,
    },
    {
      codigo: "invitados_virt",
      nombre: "invitadosVirtual",
      componente: () => InvitadosVirtualEstudiante,
    },
    {
      codigo: "invitados_virt_adm",
      nombre: "InvitadosVirtualGestion",
      componente: () => InvitadosVirtualGestion,
    },
    {
      codigo: "inscripcionesPos_act",
      nombre: "gestion_inscripciones_posgrados",
      componente: () => InscripcionesPosgrados,
    },
    {
      codigo: "iretos_act",
      nombre: "retos",
      componente: () => RetosEstudiantes,
    },
    {
      codigo: "retos_act",
      nombre: "gestion_retos",
      componente: () => RetosAdministrar,
    },
    {
      codigo: "promocion_act",
      nombre: "promocion",
      componente: () => PromocionAdministrar,
    },
    {
      codigo: "salas_act",
      nombre: "salas",
      componente: () => Bloques,
    },
    {
      codigo: "admin_salas",
      nombre: "adminsalas",
      componente: () => AdminSalas,
    },
    {
      codigo: "curso_formacion_estudiante",
      nombre: "curso_estudiante",
      componente: () => CursoEstudiante,
    },
    {
      codigo: "gestion_curso_formacion",
      nombre: "gestion_curso",
      componente: () => GestionarCurso,
    },
    {
      codigo: "atencion_reporte",
      nombre: "atencion",
      componente: () => AtencionEstudiantes
    },
    {
      codigo: "atencion_reporte_adm",
      nombre: "atencion_adm",
      componente: () => AtencionAdministrar
    },
    {
      codigo: "sisef_act",
      nombre: "mentora",
      componente: () => Sisef,
    },
    {
      codigo: "sisef_est_act",
      nombre: "mi_mentora",
      componente: () => SisefEstudiante,
    },
    {
      codigo: "autogestion_estudiantil_act",
      nombre: "autogestion_estudiantil",
      componente: () => AutogestionEstudiante,
    },
    {
      codigo: "bienestar_est_act",
      nombre: "bienestar_estudiantil",
      componente: () => BienestarEstudiante,
    },
    {
      codigo: "bienestar_est_adm_act",
      nombre: "gestion_bienestar_estudiantil",
      componente: () => BienestarAdministrar,
    },
    {
      codigo: "encuesta_gen_act",
      nombre: "gestion_encuesta_genero",
      componente: () => AdminEncuestaGenero,
    },
    {
      codigo:"acom_docente",
      nombre: "acompanamientodocente",
      componente: () => Acompanamiento,
    },
    {
      codigo:"acom_adm",
      nombre: "acompanamientoadministrar",
      componente: () => AcompanamientoAdm,
    },
    {
      codigo: "alerta_generica",
      nombre: "alertas-genericas",
      componente: ()=> Alertas_Generica,
    },
    {
      codigo: "proyecto_vida_act",
      nombre: "mi_proyecto_de_vida",
      componente: ()=> ProyectoVida,
    },
    {
      codigo: "gestion_proyecto_vida_act",
      nombre: "gestion_proyectos_de_vida",
      componente: ()=> GestionProyectoVida,
    },
    {
      codigo: "biblioteca_act",
      nombre: "biblioteca",
      componente: () => Biblioteca,
    },
    {
      codigo: "biblioteca_adm_act",
      nombre: "gestion_biblioteca",
      componente: () => GestionBiblioteca,
    }
      ]
}

export const actividadesDisponibles = (actividades, path) => {
  let actividades_app = [];
  obtenerActividades().forEach((a1) =>
    actividades.forEach(({ secundario: { codigo, nombre, archivo, valora } }) => {
      if (a1.codigo === codigo) {
        a1.titulo = nombre;
        a1.imagen = api + archivo;
        if (valora !== "submodulo" || path !== "/") {
          actividades_app.push(a1);
        }
      }
    })
  )
  return actividades_app
}

export function RutasPrincipales({ actividades }) {
  const currentPath = window.location.pathname;

  return (
    <>
      <Switch>
        <Route
          exact
          path="/facecuc"
          render={(routeProps) => <Inicio {...routeProps} actividades={actividades} />}
        ></Route>
        <Route
          exact
          path="/"
          render={(routeProps) => (
            <Inicio {...routeProps} actividades={actividadesDisponibles(actividades, currentPath)} />
          )}
        ></Route>
        {actividadesDisponibles(actividades, currentPath).map((item, key) => {
          return (
            <Route
              key={key}
              exact
              path={`/${item.nombre}`}
              component={item.componente()}
            ></Route>
          )
        })}
        <Route exact path="/Preguntas" component={Preguntas} />
        <Route exact path="/encuesta/:tokenEcuesta" component={Encuesta} />
        <Route
          exact
          path="/encuesta_general/:tokenEcuesta"
          component={EncuestaGeneral}
        />
        <Route path="/practicas" component={Not_Found}>
          <Route
            exact
            path="/practicas/:id_requisito"
            component={PracticasAgregarActa}
          />
        </Route>
        <Route exact path="/politica" component={Politica} />
        <Route exact path="/encuesta_graduados/:id_programa" component={EncuestaGraduados} />
        <Route exact path="/encuesta_graduados" component={EncuestaGraduados} />
        <Route component={Not_Found}></Route>
      </Switch>
    </>
  )
}

export function RutasInicio() {
  return (
    <div>
      <Switch>
        <Route exact path='/inscripcion' component={InscripcionAgregar}></Route>
        <Route exact path="/inscripcion_posgrados" component={InscripcionPosgradoAgregar}></Route>
        <Route exact path='/matriculas_externa' component={MatriculasRT}></Route>
        <Route exact path='/consultoria' render={(props) => <SolicitudesAgregar {...props} virtual={false} />}></Route>
        <Route exact path='/consultoria_virtual' render={(props) => <SolicitudesAgregar {...props} virtual={true} />}></Route>
        <Route exact path="/sin_sesion" component={SesionTerminada} />
        <Route exact path="/Preguntas" component={Preguntas} />
        <Route exact path="/politica_privacidad" component={PoliticaPrivacidad} />
        <Route exact path="/practicas" component={Ingresar} />
        <Route exact path="/politica" component={Politica} />
        <Route
          exact
          path="/preuniversitario/edu"
          component={PreInscripcionAgregar}
        ></Route>
        <Route path="/practicas" render={() => <></>}>
          <Route
            exact
            path="/practicas/:id_requisito"
            component={PracticasAgregarActaAlt}
          />
        </Route>
        <Route component={Ingresar} />
      </Switch>
    </div>
  )
}

function BuscarEnMenu() {
  const history = useHistory();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const q = params.get("q") || "";

  const setBuscar = (dato_buscar) => {
    const p = new URLSearchParams(location.search);
    // No usar .trim() sobre el valor que se guarda: es un input controlado
    // (value={q}) que llama a setBuscar en cada tecla, asi que recortar aqui
    // borraba el espacio apenas se escribia, antes de poder teclear la
    // siguiente palabra. Solo se usa trim() para decidir si esta vacio.
    const value = dato_buscar || "";

    if (value.trim()) p.set("q", value);
    else p.delete("q");

    const search = p.toString();
    history.replace({
      pathname: "/",
      search: search ? `?${search}` : "",
    });
  };

  return (
    <div style={{ padding: "7px 4px 0 4px", width: "100%" }}>
       <div style={{ width: "100%" }}>
      <Buscar
        dato_buscar={q}
        setBuscar={setBuscar}
        className="Buscar2"
        StyleExt={{
          marginTop: 0,
          paddingLeft: 0,
          width: "calc(100% + 24px)",
          // maxWidth: "300px", 
          margin: "0 0 0 -14px", 
        }}
      />
      </div>
    </div>
  );
}

const normalizarTextoMenu = (dato = "") =>
  `${dato || ""}`
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ")
    .trim();

const filtrarActividadesSidebar = (lista = [], datoBuscar = "") => {
  const q = normalizarTextoMenu(datoBuscar);
  if (!q) return lista;
  return lista.filter((item) => {
    const titulo = normalizarTextoMenu(item?.titulo);
    const nombre = normalizarTextoMenu(item?.nombre);
    return titulo.includes(q) || nombre.includes(q);
  });
};

export const menuPrincipal = (modulo, actividades, datoBuscar = "") => {
  const actividadesSidebar = filtrarActividadesSidebar(
    actividadesDisponibles(actividades, '/'),
    datoBuscar
  );

  return (
    <div>
      <BuscarEnMenu />
      <div style={{ height: 16 }} />
      <ListItem button component={Link} to="/" selected={modulo === "/"}>
        <ListItemIcon style={{ minWidth: 40 }}>
          <HomeIcon style={{ fontSize: 22, color: modulo === "/" ? 'var(--primary-color)' : '#62727b' }} />
        </ListItemIcon>
        <ListItemText primary={<Typography style={{ fontWeight: 600, color: modulo === "/" ? 'var(--primary-color)' : '#62727b', textTransform: 'capitalize' }}>
          Inicio
        </Typography>} />
      </ListItem>
      {actividadesSidebar.map(
        ({ nombre, titulo, imagen }, key) => {
          return (
            <ListItem
              button
              component={Link}
              to={`/${nombre}`}
              selected={modulo === `/${nombre}`}
              key={key}
            >
              <ListItemIcon>
                <img
                  src={imagen}
                  alt={titulo}
                  style={{ width: "25px", maxHeight: "25px" }}
                />
              </ListItemIcon>
              <ListItemText primary={
                <Typography style={{ fontWeight: 600, color: '#62727b', textTransform: 'capitalize' }}>
                  {titulo}
                </Typography>
              } />
            </ListItem>
          )
        }
      )}
    </div>
  );
}

export const menuSecundario = (CerrarApp) => (
  <div>
    {/* <ListItem button>
      <ListItemIcon>
        <img src={account} style={{ width: '25px', maxHeight: "25px" }} alt="Mi Cuenta" />
      </ListItemIcon>
      <ListItemText primary="Mi cuenta" />
    </ListItem>
    <ListItem button>
      <ListItemIcon>
        <img src={dictionary} style={{ width: '25px', maxHeight: "25px" }} alt="Manuales" />
      </ListItemIcon>
      <ListItemText primary="Manuales" />
    </ListItem> */}
    <ListItem button onClick={CerrarApp.bind(this, true)}>
      <ListItemIcon style={{ minWidth: 40 }}>
        <ExitToAppIcon style={{ fontSize: 22, color: '#62727b' }} />
      </ListItemIcon>
      <ListItemText primary={<Typography style={{ fontWeight: 600, color: '#62727b', textTransform: 'capitalize' }}>
        Cerrar Sesión
      </Typography>}/>
    </ListItem>
  </div>
)